export const MULTI_SELECT_LOCALE_ZHCHT = {
    leftTitle: 'æªé¸æ',
    rightTitle: 'å·²é¸æ',
    noDataMoveMessage: 'è«é¸æè¦ç§»åçæ¸æã',
    shiftRight: 'å³ç§»',
    shiftLeft: 'å·¦ç§»',
    allShiftRight: 'å¨é¨å³ç§»',
    allShiftLeft: 'å¨é¨å·¦ç§»',
    top: 'ç½®é ',
    bottom: 'ç½®åº',
    shiftUp: 'ä¸ç§»',
    shiftDown: 'ä¸ç§»',
    emptyData: 'æ«ç¡æ¸æ',
    filterPlaceholder: 'è¼¸å¥ç¯©é¸é åç¨±æç´¢'
};
